export default __webpack_public_path__ + "static/media/domains.49cb3ff5.png";